export function StarFilled({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span data-testid="star-filled-icon" className={`icon ${className}`}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.2975 2.63251L11.6175 5.27251C11.7975 5.64001 12.2775 5.99251 12.6825 6.06001L15.075 6.45751C16.605 6.71251 16.965 7.82251 15.8625 8.91751L14.0025 10.7775C13.6875 11.0925 13.515 11.7 13.6125 12.135L14.145 14.4375C14.565 16.26 13.5975 16.965 11.985 16.0125L9.74249 14.685C9.33749 14.445 8.66999 14.445 8.25749 14.685L6.01499 16.0125C4.40999 16.965 3.43499 16.2525 3.85499 14.4375L4.38749 12.135C4.48499 11.7 4.31249 11.0925 3.99749 10.7775L2.13749 8.91751C1.04249 7.82251 1.39499 6.71251 2.92499 6.45751L5.31749 6.06001C5.71499 5.99251 6.19499 5.64001 6.37499 5.27251L7.69499 2.63251C8.41499 1.20001 9.58499 1.20001 10.2975 2.63251Z"
          fill="currentColor"
        />
      </svg>
    </span>
  );
}
